import React, { useState } from 'react';
import { useEffect } from 'react';
import { 
  Box, 
  Typography, 
  TableContainer, 
  Table, 
  TableHead, 
  TableBody, 
  TableRow, 
  TableCell, 
  TextField, 
  Container, 
  Grid, 
  Paper 
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import InventoryApiService from '../services/InventoryApiService';
import { 
  Ec2InstanceDetails, 
  RDSInstanceDetails, 
  useZustStore 
} from '../state/Zuststore';
import APIConstants from '../services/APIConstants';
import LoadingIndicator from './common/inventory/LoadingIndicator';

export default function InventorySavingCost() {
  const isSmallScreen = useMediaQuery('(max-width: 700px)');
  const instanceDetails = Ec2InstanceDetails((state) => state.instanceDetails);
  const RDSinstanceDetails = RDSInstanceDetails((state) => state.RDSinstanceDetails);
  console.log(RDSinstanceDetails)
  const dopen = useZustStore((state) => state.dopen);
  const [changesDate, setChangesDate] = useState(dayjs().subtract(3, 'day'));
  const [changestoDate, setChangestoDate] = useState(dayjs().subtract(0, 'day'));
  const [ec2hours, setEc2hours] = useState();
  const [ec2savingcost, setEc2SavingCost] = useState()
  const [loading, setloading] = useState(true)
  const [ec2totalSavingCost, setEc2TotalSavingCost] = useState()
  const [rdshours, setRdshours] = useState();
  const [rdssavingcost, setRdsSavingCost] = useState()
  const [rdstotalSavingCost, setRdsTotalSavingCost] = useState()

  useEffect(() => {
    const fetchData = async () => {
      try {
        setloading(true)

        let apiRequestList = []

        if (changesDate && changestoDate) {
          const dateRequestBody = {
            fromDate: encodeURIComponent(changesDate.toISOString()),
            toDate: encodeURIComponent(changestoDate.toISOString())
          }

          apiRequestList = [
            ...apiRequestList,
            InventoryApiService.getALLCost(APIConstants.ENDPOINT_INVENTORY_EC2_CHANGES, {
              ...dateRequestBody,
              instanceId: instanceDetails.InstanceID
            }),
            InventoryApiService.getALLCost(APIConstants.ENDPOINT_INVENTORY_RDS_CHANGES, {
              ...dateRequestBody,
              instanceId: RDSinstanceDetails.DBIdentifier
            })
          ]
        } else {
          apiRequestList = [
            ...apiRequestList,
            Promise.resolve(null),
            Promise.resolve(null),
          ]
        }

        const [ec2res, rdsres] = await Promise.all(apiRequestList);

        if (ec2res) {
          setEc2hours(ec2res?.hoursMap);
          setEc2SavingCost(ec2res?.prices);
          setEc2TotalSavingCost(ec2res?.TotalSavingCost);
        }
        if (rdsres) {
          setRdshours(rdsres?.hoursMap);
          setRdsSavingCost(rdsres?.prices);
          setRdsTotalSavingCost(rdsres?.TotalSavingCost);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setloading(false)
      } finally {
        setloading(false)
      }
    };

    fetchData();
  }, [instanceDetails, RDSinstanceDetails, changesDate, changestoDate]);

  if (loading) {
    return (
      <>
        <LoadingIndicator />
      </>

    );
  }
  return (
    <Box
      component="main"
      sx={{
        backgroundColor: (theme) =>
          theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[900],
        flexGrow: 1,
        // height: '100vh',
        overflow: 'auto',
      }}
    >

      {/* <Toolbar /> */}

      <Container
        maxWidth='false'
        sx={{
          mt: '1vw',
          ml: '0',
          mr: '0',
          width: '100%',
          maxWidth: '100%'
        }}

        style={{
          // maxHeight: '87vh',
          // height: '100%',
          // overflowY: 'auto'
          height: 'calc(100vh - 82px)'
        }}
      >
        <Grid component={Paper} container style={{
          marginTop: '80px',
          padding: '10px'
        }}>
          <Grid item>
            <Typography variant='h6'>Instance Details</Typography>
            {instanceDetails && <TableContainer >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 550 }}>Name</TableCell>
                    <TableCell sx={{ fontWeight: 550 }}>Instance ID</TableCell>
                    <TableCell sx={{ fontWeight: 550 }}>Instance State</TableCell>
                    <TableCell sx={{ fontWeight: 550 }}>Instance Type</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {instanceDetails && (
                    <TableRow>
                      <TableCell>{instanceDetails.name}</TableCell>
                      <TableCell>{instanceDetails.InstanceID}</TableCell>
                      <TableCell>{instanceDetails.InstanceState}</TableCell>
                      <TableCell>{instanceDetails.InstanceType}</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>}
            {instanceDetails && <Box>
              <Box sx={{ display: "flex" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['DatePicker']}>
                    <DemoItem label="From Date">
                      <DatePicker
                        value={changesDate}
                        onChange={(newDate) => setChangesDate(newDate.startOf('day'))}
                        renderInput={(props) => (
                          <TextField {...props} variant="outlined" margin="normal" fullWidth />
                        )}
                        format="MM/DD/YYYY"
                      />
                    </DemoItem>
                  </DemoContainer>
                </LocalizationProvider>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer sx={{ marginLeft: "1rem" }} components={['DatePicker']}>
                    <DemoItem label="To Date">
                      <DatePicker
                        value={changestoDate}
                        onChange={(newDate) => setChangestoDate(newDate.startOf('day'))}
                        renderInput={(props) => (
                          <TextField {...props} variant="outlined" margin="normal" fullWidth />
                        )}
                        format="MM/DD/YYYY"
                      />
                    </DemoItem>
                  </DemoContainer>
                </LocalizationProvider>
              </Box>
              {!ec2totalSavingCost || !rdstotalSavingCost ? <Typography variant="h6" marginTop={3}>No record Found !</Typography> :
                <>
                  <Box sx={{ marginTop: "1rem" }}>
                    <Typography variant='body1' fontWeight={550}>Total hours </Typography>
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ fontWeight: 550 }}>Instance Type</TableCell>
                            <TableCell sx={{ fontWeight: 550 }}>Hours</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {ec2hours && Object.entries(ec2hours).map(([key, value]) => (
                            <TableRow key={key}>
                              <TableCell>{key}</TableCell>
                              <TableCell>{value}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                  <Box sx={{ marginTop: "2rem" }}>
                    <Typography variant='body1' fontWeight={550}>Saving Cost</Typography>
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ fontWeight: 550 }}>Instance Type</TableCell>
                            <TableCell sx={{ fontWeight: 550 }}>Saving Cost</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {ec2savingcost?.map((item, index) => (
                            <TableRow key={index}>
                              <TableCell>{item.InstanceType}</TableCell>
                              <TableCell>{item.SavingCost}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <Box sx={{ marginTop: "1rem" }}>
                      <Typography variant='body1' fontWeight={550}>TotalSavingCost : {ec2totalSavingCost && ec2totalSavingCost[0]?.TotalSavingCost} $</Typography>
                    </Box>
                  </Box>
                </>}
            </Box>}

            {RDSinstanceDetails && <TableContainer >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 550 }}>DB identifier</TableCell>
                    <TableCell sx={{ fontWeight: 550 }}>Status</TableCell>
                    <TableCell sx={{ fontWeight: 550 }}>Engine</TableCell>
                    <TableCell sx={{ fontWeight: 550 }}>Size</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {RDSinstanceDetails && (
                    <TableRow>
                      <TableCell>{RDSinstanceDetails.DBIdentifier}</TableCell>
                      <TableCell>{RDSinstanceDetails.Status}</TableCell>
                      <TableCell>{RDSinstanceDetails.Engine}</TableCell>
                      <TableCell>{RDSinstanceDetails.Size}</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>}
            {RDSinstanceDetails && <Box>
              <Box sx={{ display: "flex" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['DatePicker']}>
                    <DemoItem label="From Date">
                      <DatePicker
                        value={changesDate}
                        onChange={(newDate) => setChangesDate(newDate.startOf('day'))}
                        renderInput={(props) => (
                          <TextField {...props} variant="outlined" margin="normal" fullWidth />
                        )}
                        format="MM/DD/YYYY"
                      />
                    </DemoItem>
                  </DemoContainer>
                </LocalizationProvider>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer sx={{ marginLeft: "1rem" }} components={['DatePicker']}>
                    <DemoItem label="To Date">
                      <DatePicker
                        value={changestoDate}
                        onChange={(newDate) => setChangestoDate(newDate.startOf('day'))}
                        renderInput={(props) => (
                          <TextField {...props} variant="outlined" margin="normal" fullWidth />
                        )}
                        format="MM/DD/YYYY"
                      />
                    </DemoItem>
                  </DemoContainer>
                </LocalizationProvider>
              </Box>
              {!ec2totalSavingCost || !rdstotalSavingCost ? <Typography variant='h5' marginTop={5}>No record Found !</Typography> :
                <>
                  <Box sx={{ marginTop: "1rem" }}>
                    <Typography variant='body1' fontWeight={550}>Total hours </Typography>
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ fontWeight: 550 }}>Instance Details</TableCell>
                            <TableCell sx={{ fontWeight: 550 }}>Hours</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rdshours && Object.entries(rdshours).map(([key, value]) => (
                            <TableRow key={key}>
                              <TableCell>{key}</TableCell>
                              <TableCell>{value}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                  <Box sx={{ marginTop: "2rem" }}>
                    <Typography variant='body1' fontWeight={550}>Saving Cost</Typography>
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ fontWeight: 550 }}>Engine</TableCell>
                            <TableCell sx={{ fontWeight: 550 }}>StorageTypes</TableCell>
                            <TableCell sx={{ fontWeight: 550 }}>AllocatedStorage</TableCell>
                            <TableCell sx={{ fontWeight: 550 }}>DBInstanceClass</TableCell>
                            <TableCell sx={{ fontWeight: 550 }}>SavingCost</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rdssavingcost?.map((item, index) => (
                            <TableRow key={index}>
                              <TableCell>{item.Engine}</TableCell>
                              <TableCell>{item.StorageTypes}</TableCell>
                              <TableCell>{item.AllocatedStorage}</TableCell>
                              <TableCell>{item.DBInstanceClass}</TableCell>
                              <TableCell>{item.SavingCost}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <Box sx={{ marginTop: "1rem" }}>
                      <Typography variant='body1' fontWeight={550}>TotalSavingCost : {rdstotalSavingCost && rdstotalSavingCost[0]?.TotalSavingCost} $</Typography>
                    </Box>
                  </Box>
                </>}
            </Box>}
          </Grid>

        </Grid>
      </Container>
    </Box>
  );
};
